module.exports = require("ky");